<template>
  <div class="question-list-wrap">
    <!-- 题目列表 -->
    <swiper
      class="question-list-swiper swiper-container"
      :options="swiperOption"
      ref="questionListSwiper"
    >
      <swiperSlide
        v-for="(item, index) in questionInfoList"
        :key="item.question_id"
        class="question_item_slider"
        :class="{
          'compound-question_item_slider': item.isCompoundQuestion,
        }"
      >
        <!-- 复合题 -->
        <compound-question
          v-if="item.isCompoundQuestion"
          :question-info="item"
          :swiper-index="index"
        />
        <!-- 单一题 -->
        <div class="single-question-wrap" v-else>
          <choice-question :question-info="item" :swiper-index="index" />
        </div>
      </swiperSlide>
    </swiper>
    <!-- 底部操作区 -->
    <div
      class="bottom-operate-wrap"
      :class="{
        first: activeIndex === 0,
        last:
          activeIndex === showQuestionList.length - 1 && !showAnswerSheetBtn,
        'is-corrected': isCorrected,
        'compound-question-btn-wrap': questionInfo.pid,
      }"
    >
      <button
        class="previous-btn"
        v-show="activeIndex !== 0"
        @click="changeQuestion(activeIndex - 1, activeIndex)"
      >
        上一题
      </button>
      <button
        v-show="activeIndex !== showQuestionList.length - 1"
        class="next-btn"
        @click="changeQuestion(activeIndex + 1, activeIndex)"
      >
        下一题
      </button>
      <button
        v-show="
          showAnswerSheetBtn && activeIndex === showQuestionList.length - 1
        "
        class="next-btn"
        @click="showAnswerSheet"
      >
        进入答题卡
      </button>
    </div>
  </div>
</template>

<script>
import { QUESTION_TYPE_NAME } from "@saas/components/src/constants/question";
import intro from "@saas/components/src/introConfig/introConfig.js";
import { EventBus } from "@saas/components/src/utils/event-bus";
import CompoundQuestion from "@saas/pages/src/homework/components-mobile/CompoundQuestion.vue";
import ChoiceQuestion from "@saas/pages/src/homework/components-mobile/ChoiceQuestion.vue";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  props: {
    showIntro: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    let _this = this;
    return {
      swiperOption: {
        centeredSlides: true, // 让活动幻灯片居中显示
        slidesPerView: "auto", // 自动根据幻灯片宽度布局
        autoplay: false,
        loop: false,
        observer: true,
        observeParents: true,
        noSwipingClass: "nested-scrollable", // 指定类名，Swiper 会忽略该类名元素的滑动操作
        on: {
          slideChangeTransitionEnd: function () {
            // 只需要更改activeIndex即可
            EventBus.$emit(`handleSlideChangeEnd${this.realIndex}`, {
              index: this.realIndex,
            });
          },
        },
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      // 安装后-首次进入-展示指引
      let hadShowGuide = window?.localStorage?.getItem("hadShowGuide");
      console.log(
        "hadShowGuide====",
        hadShowGuide,
        window?.localStorage?.getItem
      );
      if (this.showIntro && !hadShowGuide && this.showAnswerSheetBtn) {
        this.guide();
      }
    });
    // 处理自动跳转下一题
    EventBus.$off(`answer-sheet-auto-next-question`);
    EventBus.$on(`answer-sheet-auto-next-question`, () =>
      this.changeQuestion(this.activeIndex + 1, this.activeIndex)
    );
    // 显示滑动指引
    EventBus.$off(`show-swiper-guide`);
    EventBus.$on(`show-swiper-guide`, () => {
      if (this.showIntro) {
        this.guide("showSwiperGuide");
      }
    });
  },
  methods: {
    ...mapMutations("defaultHomework", ["setActiveIndex"]),
    guide(type) {
      let steps = [];
      if (type === "showSwiperGuide") {
        steps = [
          {
            element: document.querySelector("#intro-step1"), // 定位到相应的元素位置，如果不设置element，则默认展示在屏幕中央
            intro: `<img  src='${require("../../../assets/images/homework/switch-guide.png")}'alt=""/>`, // 内容
            tooltipClass: "homework-step1 homework-tooltip",
          },
        ];
      } else {
        steps = [
          {
            element: document.querySelector("#intro-step2"),
            intro: `<img  src='${require("../../../assets/images/homework/mark-guide.png")}'alt=""/>`,
            tooltipClass: "homework-step2 homework-tooltip",
          },
          {
            element: document.querySelector("#intro-step3"),
            intro: `<img  src='${require("../../../assets/images/homework/sheet-guide.png")}'alt=""/>`,
            tooltipClass: "homework-step3 homework-tooltip",
          },
        ];
        // 判断第一题是否是多选题
        const fitstQuestionInfo = this.questionInfoList[0];
        const { isCompoundQuestion, question_type, child } = fitstQuestionInfo;
        let isMultipleChoice = false;
        if (
          isCompoundQuestion &&
          child?.[0]?.question_type === QUESTION_TYPE_NAME.MULTIPLE_CHOICE
        ) {
          isMultipleChoice = true;
        } else if (question_type === QUESTION_TYPE_NAME.MULTIPLE_CHOICE) {
          isMultipleChoice = true;
        }
        if (isMultipleChoice) {
          steps.push({
            element: document.querySelector("#intro-step1"), // 定位到相应的元素位置，如果不设置element，则默认展示在屏幕中央
            intro: `<img  src='${require("../../../assets/images/homework/switch-guide.png")}'alt=""/>`, // 内容
            tooltipClass: "homework-step1 homework-tooltip",
          });
        }
      }
      intro.setOptions({
        steps,
        highlightClass: "homework-highlight",
      });
      // 监听遮罩层的点击事件
      intro.onchange(function () {
        let overlay = document.querySelector(".introjs-overlay");
        if (overlay) {
          overlay.onclick = () => {
            if (intro._currentStep < intro._options.steps.length - 1) {
              // 若不是最后一步，切换到下一步引导
              intro.nextStep();
            } else {
              // 若是最后一步，退出引导
              intro.exit();
              //存储标识
              window.localStorage.setItem("hadShowGuide", true);
            }
          };
        }
      });
      // 开始引导
      this.$nextTick(() => {
        intro.start();
      });
    },
    showAnswerSheet() {
      this.$emit("showAnswerSheet", true);
    },
    changeQuestion(index, oldIndex) {
      let type = "pre";
      if (index > oldIndex) {
        type = "next";
      }
      let oldQuestionInfo = this.showQuestionList[oldIndex];
      let newQuestionInfo = this.showQuestionList[index];
      let questionPids = this.showErrorAnalysis
        ? this.errorQuestionPids
        : this.questionPids;
      if (oldQuestionInfo.question_pid) {
        //复合题：原小题信息和新小题信息父id是否相等
        let { question_pid, sub_index, question_type, question_id } =
          newQuestionInfo;
        if (oldQuestionInfo.question_pid === question_pid) {
          EventBus.$emit(`changeSubQuestion${oldQuestionInfo.question_pid}`, {
            id: question_id,
            subIndex: sub_index,
            big_question_type: question_type,
          });
        } else {
          const pidIndex = questionPids.findIndex(
            (item) => item === this.showQuestionList[oldIndex].question_pid
          );
          this.swiper.slideTo(type === "pre" ? pidIndex - 1 : pidIndex + 1); //swiper滑动到相对应的滑块
        }
      } else {
        // 单一题 ：上一题、下一题、slideTo，
        const pidIndex = questionPids.findIndex(
          (item) => item === this.showQuestionList[oldIndex].question_id
        );
        this.swiper.slideTo(type === "pre" ? pidIndex - 1 : pidIndex + 1); //swiper滑动到相对应的滑块
      }
      this.setActiveIndex(index);
    },
  },
  computed: {
    ...mapState("defaultHomework", [
      "questionInfoList",
      "activeIndex",
      "questionList",
      "showErrorAnalysis",
      "isCorrected",
    ]),
    ...mapGetters("defaultHomework", [
      "questionPids",
      "showQuestionList",
      "errorQuestionPids",
      "canSubmit",
      "showAnswerSheetBtn",
      "questionInfo",
    ]),
    swiper() {
      return this.$refs.questionListSwiper.swiper;
    },
    showQuestionInfoList() {
      return this.questionInfoList.filter((item) => item.right === 1);
    },
  },
  components: {
    swiper,
    swiperSlide,
    ChoiceQuestion,
    CompoundQuestion,
  },
};
</script>

<style lang="scss" scoped>
.question-list-wrap {
  height: 100%;
  .bottom-operate-wrap {
    width: 100%;
    position: fixed;
    z-index: 9;
    left: 0;
    bottom: 0;
    text-align: center;
    padding-bottom: 0.93rem;
    // padding-top: 0.37rem;
    background: #f7f8fa;
    &.compound-question-btn-wrap {
      background: #fff;
    }
    .previous-btn,
    .next-btn {
      width: 4.27rem;
      height: 1.07rem;
      border-radius: 0.53rem;
      border: 0.03rem solid #e5e6eb;
      font-weight: 400;
      font-size: 0.43rem;
      color: #1d2129;
      line-height: 1;
    }
    .next-btn {
      border-color: #bedaff;
      color: #165dff;
      margin-left: 0.64rem;
    }
    &.first {
      .next-btn {
        width: 9.15rem;
        margin-left: 0;
      }
    }
    &.last {
      .previous-btn {
        width: 9.15rem;
        margin-left: 0;
      }
    }
    &.is-corrected {
      button {
        border-color: #e5e6eb !important;
        color: #1d2129 !important;
      }
    }
  }
  .question-list-swiper {
    height: 100%;
  }
  ::v-deep .question_item_slider {
    width: 9.15rem !important;
    max-width: 10rem;
    height: 100%;
    margin: 0 0.11rem;
    &.compound-question_item_slider {
      border-radius: 0.32rem;
      background: #ffffff;
      width: 10rem !important;
      margin: 0 !important;
    }
  }
  .single-question-wrap {
    border-radius: 0.32rem;
    background: #ffffff;
    width: 9.15rem;
    padding: 1.18rem 0.32rem 0.32rem;
    height: 100%;
    position: relative;
  }
}
</style>
<style lang="scss">
// 指引样式
.homework-tooltip {
  background: #ffffff;
  border-radius: 0.48rem;
  min-width: auto;
  max-width: none;
  width: 6.93rem;
  &::before {
    content: "";
    position: absolute;
    top: calc(-100% + 0.2rem);
    left: 50%;
    width: 0.05rem;
    height: 3.9rem;
    border: 0.03rem dashed #ffffff;
  }
  .introjs-arrow {
    display: none !important;
  }
  .introjs-skipbutton {
    display: none !important;
  }
  .introjs-tooltip-header {
    display: none;
  }
  .introjs-tooltiptext {
    padding: 0;
  }
  &.homework-step1 {
    top: 5.5rem !important;
  }
  &.homework-step2 {
    top: 2.7rem !important;
    &::before {
      content: "";
      position: absolute;
      top: -1.5rem;
      left: auto;
      right: 0.43rem;
      width: 0.05rem;
      height: 1.26rem;
      border: 0.03rem dashed #ffffff;
    }
  }
  &.homework-step3 {
    top: 2.7rem !important;
    &::before {
      content: "";
      position: absolute;
      top: -1.5rem;
      left: auto;
      right: 0.43rem;
      width: 0.05rem;
      height: 1.26rem;
      border: 0.03rem dashed #ffffff;
    }
  }
}
.homework-highlight {
  height: 0.8rem;
  border-radius: 0.48rem;
}
.homework-highlight {
  box-shadow: #f7f8fa 0px 0px 1px 2px, rgba(29, 33, 41, 0.4) 0px 0px 0px 5000px !important;
}
</style>
